export default __webpack_public_path__ + "static/media/question_mark.401250ad.svg";